module.exports = __webpack_public_path__ + "img/DittoIconRGB.73d6c140.png";